export default __webpack_public_path__ + "44abf3fe503f30b7a89ce79594182218.png";